import { render } from "./VisualizeResearchData.vue?vue&type=template&id=47247996"
import script from "./VisualizeResearchData.vue?vue&type=script&lang=js"
export * from "./VisualizeResearchData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__